import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Swiper, Autoplay, Navigation, Pagination, FreeMode, Thumbs, EffectFade } from 'swiper';
import Plyr from 'plyr';
import SplitType from 'split-type';
import Popup from '../components/popup';

export default class Block03 {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.gsap = gsap;

        this.init();
    }

    init () {
        this.gsap.registerPlugin(ScrollTrigger);

        this.slider();

        if (window.innerWidth > 767) {
            this.animation();
        } else {
            this.mobile();
        }

        this.gallery();
    }

    popup (trigger, popup) {
        const title = popup.querySelector('.site-title');

        if (title && window.innerWidth > 767) {
            new SplitType(title, { types: 'chars' });
        }

        const popupWindow = popup.querySelector('.site-popup-window');
        const video = popup.querySelector('.block-03--popup-video-player');

        const { type } = popupWindow.dataset;

        if (type === 'video') {
            let player = video._plyrInstance;

            if (!player) {
                player = new Plyr(video, {
                    quality: { default: 1080 },
                    controls: ['play-large'],
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        modestbranding: 1,
                        iv_load_policy: 3,
                        disablekb: 1
                    }
                });

                video._plyrInstance = player;
            }

            new Popup({ popup, toggle: trigger, window: popupWindow }, {
                open: () => {
                        if (video._plyrInstance) {
                            player.muted = false;
                            player.currentTime = 0;
                            player.volume = 1;

                            player.play();

                            player.muted = false;
                            player.currentTime = 0;
                            player.volume = 1;
                        }

                    setTimeout(() => title.classList.add('animated'), 600);
                },
                close: () => {
                    if (video._plyrInstance) {
                        player.muted = true;
                        player.currentTime = 0;
                        player.volume = 0;

                        player.stop();
                    }

                    title.classList.remove('animated');
                }
            });
        } else {
            new Popup({ popup, toggle: trigger, window: popupWindow });
        }
    }

    slider () {
        const slider = this.el.querySelector('.block-03--list.swiper');
        if (!slider) return;

        const swiper = new Swiper(slider, {
            modules: [Autoplay, FreeMode],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 15,
            speed: 8000,
            freeMode: {
                enabled: true
            },
            autoplay: {
                delay: 0,
                disableOnInteraction: true
            },
            breakpoints: {
                768: {
                    spaceBetween: 48
                }
            }
        });

        swiper.slides.forEach((slide) => {
            const trigger = slide.querySelector('.block-03--list-trigger');
            const popup = this.el.querySelector(`.block-03--popup[data-popup=${trigger.dataset.popup}]`);

            if (!popup) return;

            this.popup(trigger, popup);
        });
    }

    gallery () {
        const slider = this.el.querySelector('.block-03--popup-gallery-slider');
        if (!slider) return;

        const thumbs = this.el.querySelector('.block-03--popup-gallery-thumbs');
        if (!thumbs) return;

        const controller = new Swiper(thumbs, {
            modules: [FreeMode, Thumbs],
            freeMode: { enabled: true },
            slidesPerView: 8,
            spaceBetween: 3,
            speed: 400,
            watchSlidesProgress: true,
            breakpoints: {
                768: { slidesPerView: 14, spaceBetween: 5 }
            }
        });

        new Swiper(slider, {
            modules: [Navigation, Pagination, EffectFade, Thumbs],
            effect: 'fade',
            slidesPerView: 1,
            speed: 400,
            navigation: {
                prevEl: this.el.querySelector('.block-03--popup-gallery-navigation-prev'),
                nextEl: this.el.querySelector('.block-03--popup-gallery-navigation-next')
            },
            pagination: {
                el: this.el.querySelector('.block-03--popup-gallery-pagination'),
                dynamicBullets: true,
                clickable: false
            },
            thumbs: { swiper: controller }
        });
    }

    animation () {
        const title = this.el.querySelector('.site-section--heading .site-title');
        const text = this.el.querySelector('.site-section--heading .site-text');
        const list = this.el.querySelector('.block-03--list');

        new SplitType(title, { types: 'chars' });

        /* Step: Content */

        {
            const timeline = this.gsap.timeline({
                scrollTrigger: {
                    trigger: this.el,
                    start: () => 'top bottom-=125px',
                    end: () => `+=${this.el.offsetHeight}px`,
                    scrub: true
                }
            });

            timeline
                .set(text,     { opacity: 0, y: '50%' })
                .set(list,     { opacity: 0 })
                .to({},        { duration: 0, onUpdate: () => title.classList.remove('animated') })
                .to({},        { duration: 1 })
                .to({},        { duration: 1, onUpdate: () => title.classList.add('animated') })
                .to(text,      { duration: 1, opacity: 1, y: 0 })
                .to(list,      { duration: 2, opacity: 1 });
        }
    }

    mobile () {
        const title = this.el.querySelector('.site-section--heading .site-title');
        const text = this.el.querySelector('.site-section--heading .site-text');
        const list = this.el.querySelector('.block-03--list');
        
        title.classList.add('site-animation', 'fade-up');
        text.classList.add('site-animation', 'fade-up');
        list.classList.add('site-animation', 'fade-in');

        [title, text, list].forEach((element) => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    once: true,
                    onEnter: () => element.classList.add('animated')
                }
            });
        });
    }
}
